<template>
  <div></div>
</template>
<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import axios from "axios";
import VueAxios from "vue-axios";

//Vue.$cookies.config("30d");

export default {
  components: {},
  data() {
    return {};
  },
  mounted() {
    if ($cookies.isKey("userid")) {
      //remove cookies
      $cookies.remove("userid");
      $cookies.remove("username");
      $cookies.remove("email");
      $cookies.remove("token");
      this.$router.push({ name: "login" });
    }
  }
};
</script>
<style>
</style>
